export default "__VITE_ASSET__BwQ5Qra6__"